import { useMemo } from "react";

import { LOCALES } from "~/constants/i18n";
import { Variables } from "~/constants/request";
import { useVariable } from "~/context/variables/hooks/use-variable";
import {
  checkIsExternalHostName,
  checkIsLinkAbsolute,
  checkIsLinkLocaleMatchPageLocale,
} from "~/helpers/link/link-checker";
import { AzureConfigurator } from "~/services/azure-configurator/azure-configurator";

export const useLink = (
  href: string,
  routerLocale: LOCALES,
): { shouldDisableLink: boolean } => {
  const isVisualizationPage = useVariable<boolean>(Variables.VISUALIZATION);
  const locale = isVisualizationPage ? routerLocale.toLowerCase() : routerLocale;
  const baseUrl = AzureConfigurator?.getConfig(locale)?.frontEndBaseUrl;
  const url = new URL(baseUrl as string);
  const isLinkLocaleMatchPageLocale = checkIsLinkLocaleMatchPageLocale(href, locale);

  const isLinkAbsolute = checkIsLinkAbsolute(href);

  const isExternalHostName = checkIsExternalHostName(href, url.host);

  const shouldDisableLink = useMemo(() => {
    if (isLinkAbsolute && isExternalHostName) {
      return false;
    }
    return !isLinkLocaleMatchPageLocale;
  }, [isExternalHostName, isLinkAbsolute, isLinkLocaleMatchPageLocale]);

  return {
    shouldDisableLink,
  };
};
